export default __webpack_public_path__ + "static/media/DouglasLopes_11.56a7675c.jpg";